<template>
  <b-modal
    :id="'fulfillments-' + item.id.toString()"
    centered
    hide-footer
    hide-header
    size="xl"
  >
    <ProcessingGif :classes="'popup-processing-image'" :processing="processing" />
    <template v-if="!processing">
      <div v-if="item.show_fulfillments && item.fulfillments && item.fulfillments.length">
        <div class="centered-block">
          <div class="step-title">Your Shipments</div>
        </div>
        <b-table striped hover :items="fulfillments" :fields="fulfillmentFields" class="fulfillments-table"></b-table>
      </div>
      <div v-else>
        <div class="centered-block">
          <div class="step-title">No shipments found</div>
        </div>
      </div>
    </template>
    <b-link block class="centered-block close-button" variant="secondary" @click="close()">&times;</b-link>
  </b-modal>
</template>

<script>
import axios from 'axios'
import { getShortDate } from '@/utils'
import ProcessingGif from '@/components/ProcessingGif'
import { FulfillmentStatus, FulfillmentStatusStrings } from '@/constants'

export default {
  name: 'Fulfillments',
  components: {ProcessingGif},
  props: {
    item: Object
  },
  data: function() {
    return {
      processing: true,
      fulfillmentFields: [
        {key: 'date'},
        {key: 'status'},
        {key: 'carrier', thClass: 'd-none d-md-table-cell', tdClass: 'd-none d-md-table-cell'},
        {key: 'method', thClass: 'd-none d-lg-table-cell', tdClass: 'd-none d-lg-table-cell'},
        {key: 'tracking', label: 'Tracking #', thClass: 'd-none d-md-table-cell', tdClass: 'd-none d-md-table-cell'},
        {key: 'rma', label: 'RMA #', thClass: 'd-none d-md-table-cell', tdClass: 'd-none d-md-table-cell'},
        {key: 'tracking_rma', label: 'Tracking/RMA', thClass: 'd-md-none', tdClass: 'd-md-none'}
      ]
    }
  },
  computed: {
    fulfillments: function() {
      let fulfillments = []

      for (let fulfillment of this.item.fulfillments) {
        let date = fulfillment.created
        const rmaNumber = ((fulfillment.status === FulfillmentStatus.RMAPending) ||
          (fulfillment.status === FulfillmentStatus.Returned)) ? fulfillment.rma_number : ''
        const trackingOrRMA = (fulfillment.status === FulfillmentStatus.RMAPending) ? rmaNumber
          : fulfillment.tracking_number

        if (fulfillment.ship_date && fulfillment.ship_date.length) {
          date = fulfillment.ship_date
        }

        if (fulfillment.delivery_date && fulfillment.delivery_date.length) {
          date = fulfillment.delivery_date
        }

        fulfillments.push({
          date: getShortDate(date),
          status: this.getDeliveryStatus(fulfillment),
          carrier: fulfillment.ship_carrier,
          method: fulfillment.ship_method,
          tracking: fulfillment.tracking_number,
          rma: rmaNumber,
          tracking_rma: trackingOrRMA
        })
      }

      return fulfillments
    }
  },
  methods: {
    close: function() {
      this.$bvModal.hide('fulfillments-' + this.item.id.toString())
    },
    getDeliveryStatus: function(fulfillment) {
      return FulfillmentStatusStrings[fulfillment.status]
    }
  },
  created() {
    if (!this.item.show_fulfillments) {
      this.processing = false // not allowed to show fulfillments, so nothing to do
    } else if (this.item.fulfillments && this.item.fulfillments.length) {
      this.processing = false // we already have them, so nothing to do
    } else {
      axios.get('/order_items/' + this.item.id.toString() + '/fulfillments/')
        .then(result => {
          this.item.fulfillments = result.data
          this.processing = false
        }, error => {
          console.error(error)
          this.processing = false
        })
    }
  }
}
</script>

<style scoped>

</style>
